import React from 'react';
import { GitBranch, Layers, X } from 'lucide-react';
import { getDraftTitle } from '../utils/draftPreviewPresentation';

export default function SandboxPreviewBanner({
  sandbox,
  onToggleChanges,
  showChanges,
  publicationControl,
  revisionNumber,
  isCommitted,
  hasNewerRevision,
  onRefresh,
  onExitPreview,
  actsOnBranch = false,
}) {
  if (!sandbox?.sandbox_id) return null;
  const title = getDraftTitle(sandbox);
  const draftLabel = isCommitted === false ? 'Working changes' : revisionNumber ? `Draft ${revisionNumber}` : null;
  return (
    <section
      aria-label="Branch preview"
      className="flex shrink-0 flex-wrap items-center gap-x-6 gap-y-2 border-b border-cyan-200/70 bg-cyan-50/60 px-4 py-3"
      data-testid="sandbox-preview-banner"
      data-sandbox-id={sandbox.sandbox_id}
    >
      <div className="flex min-w-0 flex-[1_1_18rem] items-center gap-2.5">
        <GitBranch size={18} aria-hidden="true" className="shrink-0 text-cyan-700" />
        <div className="min-w-0 flex-1">
          <div className="flex min-w-0 items-center gap-2">
            <p title={title} className="truncate text-sm font-semibold text-cyan-950">{title}</p>
            {draftLabel && <span className="shrink-0 rounded-md bg-white/80 px-1.5 py-0.5 text-[11px] font-medium text-cyan-800 ring-1 ring-inset ring-cyan-200/70">{draftLabel}</span>}
          </div>
          <p className="mt-0.5 text-xs text-cyan-800" data-testid="sandbox-preview-actions">
            {actsOnBranch
              ? <>Branch preview · Actions you run here change <span className="font-semibold">{title}</span>, not Live</>
              : 'Branch preview · This preview is read-only'}
          </p>
        </div>
      </div>
      <div className="flex min-w-0 flex-wrap items-center gap-2">
        {hasNewerRevision && (
          <button type="button" onClick={onRefresh} className="rounded-lg px-2 py-2 text-xs font-medium text-amber-800 hover:bg-amber-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700">
            Open latest changes
          </button>
        )}
        <button
          type="button"
          onClick={onToggleChanges}
          aria-pressed={Boolean(showChanges)}
          className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold text-cyan-900 ring-1 ring-inset ring-cyan-200 transition hover:bg-cyan-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700 ${showChanges ? 'bg-cyan-100' : 'bg-white/80'}`}
        >
          <Layers size={14} aria-hidden="true" />
          Changes
        </button>
        {publicationControl}
        <button
          type="button"
          onClick={onExitPreview}
          className="inline-flex items-center gap-1.5 rounded-lg px-2 py-2 text-xs font-medium text-cyan-800 hover:bg-cyan-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700"
        >
          <X size={14} aria-hidden="true" />
          Exit preview
        </button>
      </div>
    </section>
  );
}
